// As strings do voucher de hotel no esqueleto novo (`buildHotelVoucherView`, #5028), em
// arquivo próprio pelo mesmo motivo do `flight_voucher_catalog.ts`: o catálogo principal tem
// teto de 500 linhas. O `CATALOG` espalha estas três por cima das dele.
const PT_BR = {
  'trips.hotelVoucher.title': 'Hotel',
  'trips.hotelVoucher.dates': 'Estadia · {{range}}',
  'trips.hotelVoucher.checkIn': 'Check-in',
  'trips.hotelVoucher.checkOut': 'Check-out',
  'trips.hotelVoucher.confirmation': 'Confirmação',
  'trips.hotelVoucher.copyConfirmation': 'o código de confirmação',
  'trips.hotelVoucher.room': 'Quarto',
  'trips.hotelVoucher.guests_one': '{{count}} hóspede',
  'trips.hotelVoucher.guests_other': '{{count}} hóspedes',
  'trips.hotelVoucher.rooms': '{{count}} quartos',
  'trips.hotelVoucher.freeUntil': 'Cancelamento grátis até {{day}}',
  'trips.hotelVoucher.penaltyFrom': 'Multa de {{amount}} a partir de {{day}}',
};

const EN: Record<keyof typeof PT_BR, string> = {
  'trips.hotelVoucher.title': 'Hotel',
  'trips.hotelVoucher.dates': 'Stay · {{range}}',
  'trips.hotelVoucher.checkIn': 'Check-in',
  'trips.hotelVoucher.checkOut': 'Check-out',
  'trips.hotelVoucher.confirmation': 'Confirmation',
  'trips.hotelVoucher.copyConfirmation': 'the confirmation code',
  'trips.hotelVoucher.room': 'Room',
  'trips.hotelVoucher.guests_one': '{{count}} guest',
  'trips.hotelVoucher.guests_other': '{{count}} guests',
  'trips.hotelVoucher.rooms': '{{count}} rooms',
  'trips.hotelVoucher.freeUntil': 'Free cancellation until {{day}}',
  'trips.hotelVoucher.penaltyFrom': '{{amount}} penalty from {{day}}',
};

const ES: Record<keyof typeof PT_BR, string> = {
  'trips.hotelVoucher.title': 'Hotel',
  'trips.hotelVoucher.dates': 'Estancia · {{range}}',
  'trips.hotelVoucher.checkIn': 'Check-in',
  'trips.hotelVoucher.checkOut': 'Check-out',
  'trips.hotelVoucher.confirmation': 'Confirmación',
  'trips.hotelVoucher.copyConfirmation': 'el código de confirmación',
  'trips.hotelVoucher.room': 'Habitación',
  'trips.hotelVoucher.guests_one': '{{count}} huésped',
  'trips.hotelVoucher.guests_other': '{{count}} huéspedes',
  'trips.hotelVoucher.rooms': '{{count}} habitaciones',
  'trips.hotelVoucher.freeUntil': 'Cancelación gratuita hasta {{day}}',
  'trips.hotelVoucher.penaltyFrom': 'Multa de {{amount}} a partir del {{day}}',
};

export const HOTEL_VOUCHER_CATALOG = { 'pt-BR': PT_BR, en: EN, es: ES };
